/**
 * Escape CSV quotes
 * @param  {string} string to escape
 * @return {string}        escaped string
 */
export default function escapeCSVQuotes(str) {
  return ('string' !== typeof str) ?
    str :
    str.replace(/"|“|”|\u201C|\u201D/g, '""');
}



// WEBPACK FOOTER //
// ./app/utils/string/escapeCSVQuotes.js